import { useEffect, useState } from 'react';
import { DisplaySettings } from '../types/Gallery';
import { getCurrentDisplaySettings, subscribeDisplaySettings } from '../utils/DisplaySettingsAPI';

export function useDisplaySettings(): DisplaySettings {
  const [settings, setSettings] = useState<DisplaySettings>(getCurrentDisplaySettings);

  useEffect(() => subscribeDisplaySettings(setSettings), []);

  return settings;
}
